export const getButtonClickFunction =
  (
    defaultFunction: () => void,
    changeState: (state: boolean) => void,
    modalStateHandler: () => void
  ): (() => void) =>
  () => {
    defaultFunction();
    changeState(false);
    modalStateHandler();
  };
